import { render, staticRenderFns } from "./UrlCard.vue?vue&type=template&id=44ffb8e5"
import script from "./UrlCard.vue?vue&type=script&lang=js"
export * from "./UrlCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports